import React, {Component} from 'react'
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Constants from "../../utils/constants";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import Select from "react-select";

class PastMedications extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            past_med: this.props.past_med,
            medicationsList: this.props.medicationsList,
            isOtherPastUseMedication: this.props.isOtherPastUseMedication,

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
    }
    handleMedicationChange(event){
        this.props.onClickAddDeleteMedications(event,0,"past_med","Past")
    }

    render() {
        let {t} = this.props
        let medicationsList =this.props.medicationsList
            let {entry}=this.state
        let medicationsListArr=[medicationsList.length]
        for(let i=0;i<medicationsList.length;i++){
            medicationsListArr[i]={value:medicationsList[i].Med_ID, label:medicationsList[i].Medication_name}
        }

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>

                    <div className={'`inputSlotsHalfBlock`'}>

                        <PatientSelectComponent
                            selectWidth={'1200px'}

                            placeholder={t('patient_boarding.med_choose')}
                            options={medicationsListArr}
                            value={this.props.past_med}
                            isMulti={true}
                            onChange={this.handleMedicationChange.bind(this)}
                        />

                    </div>

                </div>
                <div className={'patientsFormRow'}>

                {this.props.isOtherPastUseMedication&&
                <div className={'inputSlots'}>
                    <label className={'infoLabel'} >{t('patient_boarding.Enter_other_med')}</label>
                    <input className={'inputBoxStyle'} type="text"  name="ID" defaultValue={entry.PastUseOtherMed}
                           onChange={(event) => this.props.onValueChange("PastUseOtherMed", event.target.value)}/>
                </div>}



            </div>
                <div className={'patientsFormRow'}>

                <div className={'inputSlotsDoc-full'}>
                    <label className={'infoLabel'}>{t('patient_boarding.Comments')}</label>
                    <textarea  className={'info-inputBoxStyle2'} defaultValue={entry.Comments}
                               maxLength={5000}
                               onChange={(event) => this.props.onValueChange("Comments", event.target.value)}/>
                </div>

            </div>
            </div>

        )
    }
}

PastMedications.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default PastMedications;
